module.exports = __webpack_public_path__ + "static/media/gear.971e612b.svg";